import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'src/environments/environment.prod';
import { ApiService } from 'src/services/apiService';
import { AuthService } from 'src/services/auth.service';

@Component({
  selector: 'app-services',
  templateUrl: './services.component.html',
  styleUrls: ['./services.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class ServicesComponent implements OnInit {

  services: any[] = [];
  services2: any[] = [];

  // Search arrays
  filteredServices: any[] = [];
  filteredServices2: any[] = [];
  searchText: string = '';

  serviceCard: any;
  selectedServiceId: string = "";
  sectionName: string = "";
  index = 0;
  sectionId: string | undefined;
  SectionIdEnv: string = "";

  constructor(
    private apiService: ApiService,
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService
  ) {

    this.SectionIdEnv = environment.SectionId;

    if (this.route.snapshot.queryParams['SectionId']) {

      this.sectionId = this.route.snapshot.queryParamMap.get('SectionId')!;

      if (this.sectionId != null) {

        this.apiService
          .get('categorization/GetServicesWithSectionId?id=' + this.sectionId)
          .subscribe(response => {

            this.services = response.data;
            this.filteredServices = [...this.services];

          });

        this.getSectionName();

      } else {

        location.href = '/Entities';
        return;

      }

    }

    if (this.route.snapshot.queryParams['index']) {
      this.index = Number(this.route.snapshot.queryParamMap.get('index')!);
    }

    if (this.sectionId == "64c645e7784dace19463df16") {
      this.getOldWebsiteRequest();
    }

  }

  ngOnInit(): void {
  }

  normalizeArabic(text: string): string {
  if (!text) return '';

  return text
    .toLowerCase()
    .trim()
    .replace(/[أإآٱ]/g, 'ا')
    .replace(/ؤ/g, 'و')
    .replace(/ئ/g, 'ي')
    .replace(/ى/g, 'ي')
    .replace(/ة/g, 'ه')
    .replace(/ـ/g, '')
    .replace(/[\u064B-\u065F\u0670]/g, '') // Remove tashkeel
    .replace(/\s+/g, ' ');
}

  getOldWebsiteRequest() {

    this.apiService
      .get('Moin/GetServices?category=15')
      .subscribe(response => {

        this.services2 = response.data;
        this.filteredServices2 = [...this.services2];

      });

  }

  getSectionName() {

    if (this.route.snapshot.queryParams['MainSectionId']) {

      const mainSectionId = this.route.snapshot.queryParamMap.get('MainSectionId')!;

      this.apiService
        .get(`categorization/GetSectionsWithEntityId?id=${mainSectionId}`)
        .subscribe(response => {

          const sections = response.data as any[];

          const section = sections.filter(
            x => x.id == this.route.snapshot.queryParams['SectionId']
          )[0];

          if (section) {
            this.sectionName = section.name;
          }

        });

    }

  }

 filterServices(): void {

  const keyword = this.normalizeArabic(this.searchText.trim());

  if (!keyword) {
    this.filteredServices = [...this.services];
    this.filteredServices2 = [...this.services2];
    return;
  }

  this.filteredServices = this.services.filter(service =>
    this.normalizeArabic(service.name || '').includes(keyword)
  );

  this.filteredServices2 = this.services2.filter(service =>
    this.normalizeArabic(service.title || '').includes(keyword)
  );

}

  clearSearch(): void {

    this.searchText = '';
    this.filterServices();

  }

  colorArr: string[] = [
    'bg-gold-2',
    'bg-maroon',
    'bg-gold',
    'bg-green',
    'bg-blue',
    'bg-red',
    'bg-blue',
    'bg-gold',
    'bg-green',
    'bg-blue',
  ];

  textColorArr: string[] = [
    'text-gold-2',
    'text-maroon',
    'text-gold',
    'text-green',
    'text-blue',
    'text-red',
    'text-blue',
    'text-gold',
    'text-green',
    'text-blue',
  ];

  imagesArr: string[] = [
    '../../assets/images/window.png',
    '../../assets/images/investor.png',
    '../../assets/images/motiviation.png',
    '../../assets/images/build.png',
    '../../assets/images/ease.png',
    '../../assets/images/jordan-star.png',
    '../../assets/images/grievance.png',
    '../../assets/images/invest-box.png',
    '../../assets/images/one-approval.png',
    '../../assets/images/ease.png',
  ];

  apply(item: any) {

    if (item.redirectionUrl == "") {

      this.router.navigateByUrl(
        `/Form?BluePrintId=${item.id}&SectionId=${this.sectionId}`
      );

    } else {

      window.open(item.redirectionUrl, '_blank');

    }

  }

  openForm(id: string) {

    window.open(
      `${environment.oldWebsite}/ar/portal/in?token=${this.authService.getToken()}&model=service&id=${id}`
    );

  }

}